<template>
  <div style="width:900px;">
    <div>
      <p class="titleMarginTop mb-0 title font-weight-light font-weight-bold">
        포인트 상품 만들기
      </p>
      <p class="mb-0 mt-0 subtitle-2 font-weight-medium">
        판매하시려는 포인트 상품 가격과 지급하시려는 포인트(적립금)를 입력하여
        저장합니다.
      </p>
      <p class="mb-0 mt-0 subtitle-2 font-weight-medium">
        추가하기 버튼을 클릭하여 여러개의 포인트 상품을 추가하여 만들 수
        있습니다.
      </p>
      <p class="mb-0 mt-0 subtitle-2 font-weight-medium">
        만들어진 포인트 상품은 카페24 상품으로 생성되어 연동되오니 참고해주세요.
      </p>
    </div>

    <div class="row ml-0 mt-5 align-end" height="50px" style="width:900px;">
      <div class="float-left">
        <v-btn
          large
          color="grey darken-4"
          class="white--text float-left"
          dense
          @click="createProductModalShow()"
          >+ 포인트 상품 만들기</v-btn
        >
      </div>
      <div
        v-show="product_list.length > 0"
        class="float-right align-end"
        style="margin-left: 409px;"
      >
        <v-btn
          small
          color="green"
          class="white--text float-right"
          dense
          @click="showRequireCheckImage()"
          >※ 포인트 상품 만든 후 필수 체크. 확인해주세요</v-btn
        >
      </div>
    </div>

    <div
      v-if="product_list.length > 0"
      class="mt-0 d-inline-block"
      style="width:900px;"
    >
      <div>
        <div
          v-for="(param, index) in product_list"
          :key="index"
          class="mt-3 mb-0 d-inline-block"
        >
          <v-card
            width="900"
            outlined
            style="background-color: rgb(246, 246, 246);"
          >
            <div class="d-flex">
              <v-card width="200" outlined class="pt-0 ml-4 mr-3 mt-4 mb-4">
                <v-card-text class="pa-0">
                  <div class="text-center">
                    <p
                      style="padding-top:2px; font-size:0.8rem; color: rgba(0, 0, 0, 0.6);"
                      class="mt-3"
                    >
                      판매가격
                    </p>
                    <p
                      style="font-size: 1.2rem; padding-top:2px;"
                      class="black--text hover"
                      @click="updateProductModalShow(param)"
                    >
                      {{ param.price | comma }}원
                    </p>
                  </div>
                </v-card-text>
              </v-card>
              <v-card width="200" outlined class="pt-0 mr-1 mt-4 mb-4">
                <v-card-text class="pa-0">
                  <div class="text-center">
                    <p
                      style="padding-top:2px;  font-size:0.8rem; color: rgba(0, 0, 0, 0.6);"
                      class="mt-3"
                    >
                      지급포인트
                    </p>
                    <p
                      style="font-size: 1.2rem; padding-top:2px;"
                      class="black--text hover"
                      @click="updateProductModalShow(param)"
                    >
                      {{ param.points | comma }} P
                    </p>
                  </div>
                </v-card-text>
              </v-card>
              <div class="float-left mt-7 ml-3" style="width:454px;">
                <div class="float-left">
                  <ul>
                    <li class="float-left mt-1">
                      카페24 포인트 상품 노출 설정
                      <template>
                        <div class="text-center float-right">
                          <div style="display: flex;">
                            <v-tooltip
                              v-model="param.product_display_tooltip_show"
                              bottom
                              content-class="product_display_tooltip_show"
                            >
                              <template v-slot:activator="{ attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  class="ml-2"
                                  @click="tooltipShow(param, index)"
                                  color="#8C8C8C"
                                  size="22"
                                  >mdi-alert-circle</v-icon
                                >
                              </template>
                              <div>
                                <p class="text-left mb-4">
                                  ※ 꼭 확인해주세요!
                                </p>
                                <p class="text-left mb-0">
                                  생성하신 포인트 상품은 카페24 상품으로
                                  생성되어 주문과 연결됩니다.
                                </p>
                                <p class="text-left mb-0">
                                  아래의 쇼핑몰 화면 설정까지 완료하시면
                                  노출/판매 상태로 변경하셔야
                                </p>
                                <p class="text-left mb-0">
                                  쇼핑몰 회원들이 구매가 가능합니다.
                                </p>
                                <p class="text-left mb-0">
                                  판매를 중지할 경우는 해당 상품의
                                  미노출/미판매로 변경하시면 됩니다.
                                </p>
                              </div>
                            </v-tooltip>
                          </div>
                        </div>
                      </template>
                    </li>
                  </ul>
                </div>
                <div class="d-flex float-left">
                  <div class="d-flex float-left mt-4">
                    <p
                      class="pt-2 ml-6"
                      style="font-size:0.8rem; color: rgba(0, 0, 0, 0.6);"
                    >
                      진열상태
                    </p>
                    <v-switch
                      :loading="param.display_loading"
                      :disabled="switch_disabled"
                      hide-details
                      inset
                      class="mt-0 ml-3 mb-0"
                      value="enabled"
                      v-model="param.display_status"
                      @change="productDisplaySatatus(param)"
                    ></v-switch>
                  </div>
                  <div class="d-flex float-left mt-4">
                    <p
                      class="pt-2"
                      style="font-size:0.8rem; color: rgba(0, 0, 0, 0.6);"
                    >
                      판매상태
                    </p>
                    <v-switch
                      :loading="param.sales_loading"
                      :disabled="switch_disabled"
                      hide-details
                      inset
                      class="mt-0 ml-3 mb-0"
                      value="enabled"
                      v-model="param.selling_status"
                      @change="productSaleSatatus(param)"
                    ></v-switch>
                  </div>
                </div>

                <div
                  class="mr-0 mb-0 mt-0 pt-0 pb-0 d-flex"
                  style="height: 100px;"
                >
                  <div class="float-right mr-0 mb-0 mt-0 pt-0 pb-0">
                    <v-btn
                      depressed
                      small
                      class="font-weight-black white--text float-right mr-4 mt-1"
                      aling="right"
                      @click="deleteProduct(param)"
                      style="background-color: rgb(127, 127, 127); border-color: rgb(127, 127, 127);"
                      width="120"
                      >포인트 상품 삭제</v-btn
                    >
                    <v-btn
                      depressed
                      small
                      class="font-weight-black white--text float-right mr-4 mt-3"
                      aling="right"
                      @click="showCafe24Page(param)"
                      color="primary"
                      width="120"
                      >연결 상품 보기</v-btn
                    >
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <div v-else>
      <v-card width="900" outlined class="mt-3">
        <p class="text--disabled text-center mb-0 mt-5 mb-5">
          포인트 상품을 만들어주세요.
        </p>
      </v-card>
    </div>

    <CreatePointProductModal
      ref="CreatePointProductModal"
      @addProductList="addProductList"
      @updateProductList="updateProductList"
    ></CreatePointProductModal>
  </div>
</template>
<style scoped>
.product_display_tooltip_show {
  left: 730px !important;
  position: absolute;
}
</style>
<script>
import M from "@/libs/mapping.js";
import CreatePointProductModal from "@/components/mileage/sales/modal/CreatePointProductModal.vue";
import Filters from "@/libs/filters.js";
export default {
  data() {
    return {
      M,
      dialog: false,
      product_list: [],
      switch_disabled: false,
    };
  },
  methods: {
    resetData: function() {
      Object.assign(this.$data, this.$options.data());
    },
    createProductModalShow: function() {
      this.$refs.CreatePointProductModal.show();
    },
    updateProductModalShow: function(params) {
      this.$refs.CreatePointProductModal.show(params);
    },
    addProductList: function(setParams) {
      this.product_list.unshift(setParams);
    },
    updateProductList: function(setParams) {
      let info = this.product_list.find(
        (product) => product.product_no === setParams.product_no
      );
      const index = this.product_list.indexOf(info);
      this.$set(this.product_list[index], "price", setParams.price);
      this.$set(this.product_list[index], "points", setParams.points);
    },
    productDisplaySatatus: async function(param) {
      this.switch_disabled = true;
      param.display_loading = true;
      if (param.display_status != "enabled") {
        param.display_status = "disabled";
      }
      let setParams = {
        display_status: param.display_status,
      };
      try {
        await M.api(
          M.entry("/put/mileage/display", param.product_no),
          setParams
        );
        alert("상품 진열 상태 수정 되었습니다.");
      } catch (e) {
        alert("상품 진열 상태 수정 실패되었습니다.");
      }
      param.display_loading = false;
      this.switch_disabled = false;
    },
    productSaleSatatus: async function(param) {
      this.switch_disabled = true;
      param.sales_loading = true;
      if (param.selling_status != "enabled") {
        param.selling_status = "disabled";
      }
      let setParams = {
        selling_status: param.selling_status,
      };
      try {
        await M.api(
          M.entry("/put/mileage/selling", param.product_no),
          setParams
        );
        alert("상품 판매 상태 수정 되었습니다.");
      } catch (e) {
        alert("상품 판매 상태 수정 실패되었습니다.");
      }
      param.sales_loading = false;
      this.switch_disabled = false;
    },
    searchProductList: async function() {
      try {
        let result = await M.api(M.entry("/get/mileage"));
        for (let i = 0; i < result.length; i++) {
          result[i].product_display_tooltip_show = false;
          result[i].display_loading = false;
          result[i].sales_loading = false;
          this.product_list.push(result[i]);
        }
      } catch (e) {
        alert("설정 조회 실패했습니다.\n새로고침(F5)하여 재확인해주세요.");
      }
    },
    deleteProduct: async function(param) {
      if (confirm("해당 포인트 상품을 정말 삭제하시겠습니까?")) {
        try {
          await M.api(M.entry("/delete/mileage/products", param.product_no));
          alert("포인트 상품이 삭제되었습니다.");
          const index = this.product_list.indexOf(param);
          this.product_list.splice(index, 1);
        } catch (e) {
          alert("포인트 상품 삭제 실패되었습니다.");
        }
      }
    },
    tooltipShow: function(param, index) {
      for (let i = 0; i < this.product_list.length; i++) {
        if (index !== i) {
          this.product_list[i].product_display_tooltip_show = false;
        }
      }
      param.product_display_tooltip_show = !param.product_display_tooltip_show;
    },
    showRequireCheckImage: function() {
      window.open(`/images/point_require_check.jpg`, "_blank");
    },
    showCafe24Page: function(params) {
      window.open(
        ` https://${this.$store.state.mallId}.cafe24.com/disp/admin/shop1/product/ProductRegister?product_no=${params.product_no}`,
        "_blank"
      );
    },
  },
  components: {
    CreatePointProductModal,
  },
  filters: Filters,
  created: async function() {
    this.resetData();
    await this.searchProductList();
  },
  mounted: function() {
    setTimeout(() => {
      this.$parent.loadCompleted();
    }, 1000);
  },
};
</script>
